export default __webpack_public_path__ + "static/media/hourly_max_purchase.9bbb4d93.png";